import { useCallback, useEffect, useState } from 'react';
import { Area } from '../api';

// The State / District filter shared by Explore, Offers, Wine Shops, Events and Pool Parties.
// Remembered on this device, so choosing "Mumbai" on one page applies on the others too.
const KEY = 'c2n_area';
const EVENT = 'c2n-area-change';

function read(): Area {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Area;
    return parsed.state ? { state: parsed.state, district: parsed.district || null } : {};
  } catch {
    return {};
  }
}

export function useLocationFilter() {
  const [area, setAreaState] = useState<Area>(read);

  useEffect(() => {
    const sync = () => setAreaState(read());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);

  const setArea = useCallback((next: Area) => {
    const clean = next.state ? { state: next.state, district: next.district || null } : {};
    try {
      localStorage.setItem(KEY, JSON.stringify(clean));
    } catch {
      /* private mode: applies to this page only */
    }
    setAreaState(clean);
    window.dispatchEvent(new Event(EVENT));
  }, []);

  // Short label for headings, e.g. "Pune, Maharashtra" or "near you".
  const label = area.state ? (area.district ? `${area.district}, ${area.state}` : area.state) : 'near you';

  return { area, setArea, label };
}
